import React, { ReactNode } from 'react';

import { ThemeProvider } from '@mui/material/styles';
import { createTheme } from '@mui/material/styles';
import { Theme } from '@mui/material/styles';

import { DupontWaterTheme } from 'packages/ui-styles';

//const defaultTheme = createTheme(); // Material-UI's default theme

interface DupontThemeProviderProps {
  children?: ReactNode;
  theme?: Theme;
}

const getTheme = (theme: Theme | undefined) => {
  if (!theme) {
    theme = DupontWaterTheme;
  }
  return createTheme(theme);
};

const DupontThemeProvider: React.FC<DupontThemeProviderProps> = ({ children, theme }) => {
  const themeToApply = getTheme(theme);
  return <ThemeProvider theme={themeToApply}> {children} </ThemeProvider>;
};

export default DupontThemeProvider;
